var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "filters__list" },
    _vm._l(_vm.initFilters, function(filter, i) {
      return _c("li", { key: i, class: ["filters__list-group", filter.id] }, [
        _c(
          "button",
          {
            staticClass: "filters__list-group__toggle ",
            class: {
              "filters__list-group__toggle--active":
                _vm.initFilters[i].isExpanded
            },
            attrs: {
              "aria-controls": "filter_" + filter.id,
              "aria-expanded": _vm.initFilters[i].isExpanded
            },
            on: {
              click: function($event) {
                return _vm.handleOnClickButton(i)
              }
            }
          },
          [_vm._v(_vm._s(filter.label))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.initFilters[i].isExpanded,
                expression: "initFilters[i].isExpanded"
              }
            ],
            attrs: { id: "filter_" + filter.id, role: "region", tabindex: "-1" }
          },
          [
            _c(
              "component",
              _vm._b(
                {
                  on: {
                    input: function(value) {
                      return _vm.setValue(filter.id, value)
                    }
                  }
                },
                "component",
                Object.assign({}, filter.fieldData, {
                  value: _vm.value[filter.id],
                  is: filter.component
                }),
                false
              )
            )
          ],
          1
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }